export { default, getStaticPaths, getStaticProps } from 'src/pages/HallOfFame/pages/HallOfFamer'
